import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { phoneRegExp } from "../../../../../helpers/yupValidators";
import CustomInputField from "../../../../../components/CustomHTMLElements/CustomInputField";
import CustomSelectDropdown from "../../../../../components/CustomHTMLElements/CustomSelectDropdown";
import { useUpdateAdminUser } from "../../../../../components/ManageRoles/hooks/useUpdateAdminUser";

const schema = yup.object().shape({
  phone: yup
    .string()
    .required("Please enter new phone number")
    .trim()
    .matches(phoneRegExp, "Invalid Phone Number")
    .min(7, "Phone number must have at least 7 digits")
    .max(20, "Phone number cannot have more than 20 digits"),
  firstName: yup
    .string()
    .trim()
    .required("Please enter a new first name")
    .min(2, "First name must have at least 2 characters")
    .max(50, "First name cannot be longer than 50 characters"),
  lastName: yup
    .string()
    .required("Please enter a new last name")
    .min(2, "Last name must have at least 2 characters")
    .max(50, "Last name cannot be longer than 50 characters"),
  isActive: yup.boolean().required("Please select user active status"),
});

export default function EditTab({ user, onBack, onUpdateSuccess }) {
  const [isActive, setIsActive] = useState(
    user?.is_active ?? user?.isActive ?? false,
  );

  const { mutate: updateMutate, result: updateResult } = useUpdateAdminUser();
  const isUpdating = updateResult.isLoading;

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const handleUpdateSubmit = (formData) => {
    updateMutate({ id: user?.id, ...formData }, { onSuccess: onUpdateSuccess });
  };

  return (
    <form onSubmit={handleSubmit(handleUpdateSubmit)}>
      <div className="m-t-2 m-b-2">
        <CustomInputField
          type="text"
          maxLength="50"
          reference={register}
          defaultValue={user?.firstName ?? user?.first_name}
          name="firstName"
          placeholder="First Name"
          label="First Name"
          errors={errors.firstName}
          iconType="fas fa-user"
        />
      </div>
      <div className="m-t-2 m-b-2">
        <CustomInputField
          type="text"
          maxLength="50"
          reference={register}
          defaultValue={user?.lastName ?? user?.last_name}
          name="lastName"
          placeholder="Last Name"
          label="Last Name"
          errors={errors.lastName}
          iconType="fas fa-user"
        />
      </div>
      <div className="m-t-2 m-b-2">
        <CustomInputField
          type="number"
          maxLength="20"
          reference={register}
          defaultValue={user?.phoneNumber ?? user?.phone}
          name="phone"
          placeholder="Phone Number"
          label="Phone Number"
          errors={errors.phone}
          iconType="fas fa-phone"
        />
      </div>
      <div className="m-t-2 m-b-2">
        <CustomSelectDropdown
          reference={register}
          value={isActive}
          name="isActive"
          label="User Active Status"
          errors={errors.isActive}
          iconType="fas fa-star-half-alt"
          onChange={(e) => setIsActive(e.target.value)}
        >
          <option></option>
          <option value={true}>Active</option>
          <option value={false}>Inactive</option>
        </CustomSelectDropdown>
      </div>
      <div className="Form__action-buttons m-t-1">
        <button
          type="button"
          className="btn zoom-element btn login-btn m-0 mr-auto"
          onClick={onBack}
          disabled={isUpdating}
        >
          <i className="fas fa-arrow-left"></i>
          &nbsp; Back to Details
        </button>
        <button
          type="submit"
          className="btn zoom-element btn login-btn m-0 ml-auto"
          disabled={isUpdating}
        >
          <i className="fas fa-arrow-right"></i>
          &nbsp; {isUpdating ? "Updating..." : "Update User"}
        </button>
      </div>
    </form>
  );
}
